import { RetailUnitSchema } from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type EmailPreviewParams = Static<typeof EmailPreviewParamsSchema>;
export const EmailPreviewParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
  },
  { additionalProperties: false, $id: 'EmailPreviewParamsSchema' }
);

export type EmailPreviewBody = Static<typeof EmailPreviewBodySchema>;
export const EmailPreviewBodySchema = Type.Object(
  {
    emailContent: Type.Object({
      market: Type.String(),
      language: Type.String(),
      customerId: Type.String(),
      profileType: Type.String(),
      customerCategory: Type.String(),
      ikeaStoreId: Type.String(),
      membershipCardNumber: Type.String(),
      subjectLine: Type.String(),
      preHeader: Type.String(),
      bodyHeadline: Type.String(),
      ctaText: Type.String(),
      ctaLink: Type.String(),
      disclaimerText: Type.String(),
      body: Type.Object({
        copy: Type.Array(
          Type.Object({
            bodyCopy: Type.String(),
          })
        ),
      }),
      bannerImageUrl: Type.String(),
    }),
  },
  { additionalProperties: false, $id: 'EmailPreviewBodySchema' }
);
